"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var TextField_1 = require("office-ui-fabric-react/lib/TextField");
var Checkbox_1 = require("office-ui-fabric-react/lib/Checkbox");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var ListingForm_styles_1 = require("./ListingForm.styles");
var ListingForm_classNames_1 = require("./ListingForm.classNames");
var Sync_1 = require("@twii/core-ui-fabric/lib/component/Sync");
var ImageField_1 = require("../../media/component/ImageField");
var ListingApprovalStatus_1 = require("../ListingApprovalStatus");
var ValidationErrors_1 = require("@twii/core-ui-fabric/lib/component/ValidationErrors");
var ErrorUtils_1 = require("@twii/core/lib/ErrorUtils");
var ListingLinkForm_1 = require("./ListingLinkForm");
var ListingFormSection = /** @class */ (function (_super) {
    __extends(ListingFormSection, _super);
    function ListingFormSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingFormSection.prototype.render = function () {
        return (React.createElement("div", { className: this.props.className },
            React.createElement("h5", { className: this.props.titleClassName }, this.props.title),
            React.createElement("div", { className: this.props.bodyClassName }, this.props.children)));
    };
    return ListingFormSection;
}(React.Component));
var ListingImagesEditor = /** @class */ (function (_super) {
    __extends(ListingImagesEditor, _super);
    function ListingImagesEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onSmallIconChanged = function (smallIcon) {
            _this.props.listing.setSmallIcon(smallIcon);
        };
        _this._onLargeIconChanged = function (largeIcon) {
            _this.props.listing.setLargeIcon(largeIcon);
        };
        _this._onBannerIconChanged = function (bannerIcon) {
            _this.props.listing.setBannerIcon(bannerIcon);
        };
        _this._onLargeBannerIconChanged = function (largeBannerIcon) {
            _this.props.listing.setLargeBannerIcon(largeBannerIcon);
        };
        return _this;
    }
    ListingImagesEditor.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(ImageField_1.ImageField, { onChange: this._onSmallIconChanged, image: this.props.listing.small_icon, defaultSelectText: "Select Small Icon...", label: "Small Icon", width: 16, height: 16 }),
            React.createElement(ImageField_1.ImageField, { onChange: this._onLargeIconChanged, image: this.props.listing.large_icon, defaultSelectText: "Select Large Icon...", label: "Large Icon", width: 32, height: 32 }),
            React.createElement(ImageField_1.ImageField, { onChange: this._onBannerIconChanged, image: this.props.listing.banner_icon, defaultSelectText: "Select Banner Icon...", label: "Banner Icon", width: 220, height: 137 }),
            React.createElement(ImageField_1.ImageField, { onChange: this._onLargeBannerIconChanged, image: this.props.listing.large_banner_icon, defaultSelectText: "Select Large Banner Icon...", label: "Large Banner Icon", width: 1200, height: 900 })));
    };
    ListingImagesEditor = __decorate([
        mobx_react_1.observer
    ], ListingImagesEditor);
    return ListingImagesEditor;
}(React.Component));
var ListingEditor = /** @class */ (function (_super) {
    __extends(ListingEditor, _super);
    function ListingEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onTitleChanged = function (value) {
            _this.props.listing.setTitle(value);
        };
        _this._onDescriptionChanged = function (value) {
            _this.props.listing.setDescription(value);
        };
        _this._onShortDescriptionChanged = function (value) {
            _this.props.listing.setShortDescription(value);
        };
        _this._onEnabledChanged = function (e, value) {
            _this.props.listing.setEnabled(value);
        };
        _this._onFeaturedChanged = function (e, value) {
            _this.props.listing.setFeatured(value);
        };
        _this._onPrivateChanged = function (e, value) {
            _this.props.listing.setPrivate(value);
        };
        _this._onLaunchUrlChanged = function (value) {
            _this.props.listing.setLaunchUrl(value);
        };
        _this._onVersionChanged = function (value) {
            _this.props.listing.setVersion(value);
        };
        _this._onSecurityMarkingChanged = function (value) {
            _this.props.listing.setSecurityMarking(value);
        };
        return _this;
    }
    ListingEditor.prototype.render = function () {
        var styles = ListingForm_styles_1.getStyles(null, this.props.styles);
        var classNames = ListingForm_classNames_1.getClassNames(styles);
        var inputDisabled = this.props.listing.saveSync.syncing;
        var cbStyles = {
            root: {
                marginTop: 8
            }
        };
        var validationErrors = this.props.listing.validationErrors;
        var approvalStatus = this.props.listing.approval_status;
        return (React.createElement("div", { className: classNames.editor },
            React.createElement(TextField_1.TextField, { onChanged: this._onTitleChanged, value: this.props.listing.title || "", label: "Title", disabled: inputDisabled, required: true, errorMessage: ErrorUtils_1.getPropErrorMessage("title", validationErrors) }),
            React.createElement(TextField_1.TextField, { onChanged: this._onShortDescriptionChanged, value: this.props.listing.description_short || "", label: "Short Description", disabled: inputDisabled, required: approvalStatus !== ListingApprovalStatus_1.ListingApprovalStatus.IN_PROGRESS, errorMessage: ErrorUtils_1.getPropErrorMessage("description_short", validationErrors) }),
            React.createElement(TextField_1.TextField, { onChanged: this._onDescriptionChanged, value: this.props.listing.description || "", label: "Description", disabled: inputDisabled, multiline: true, rows: 6, resizable: false, required: approvalStatus !== ListingApprovalStatus_1.ListingApprovalStatus.IN_PROGRESS, errorMessage: ErrorUtils_1.getPropErrorMessage("description", validationErrors) }),
            React.createElement(TextField_1.TextField, { onChanged: this._onLaunchUrlChanged, value: this.props.listing.launch_url || "", label: "Launch URL", disabled: inputDisabled, required: this.props.listing.id ? true : false, errorMessage: ErrorUtils_1.getPropErrorMessage("launch_url", validationErrors) }),
            React.createElement(TextField_1.TextField, { onChanged: this._onVersionChanged, value: this.props.listing.version_name || "", label: "Version", disabled: inputDisabled }),
            React.createElement(TextField_1.TextField, { onChanged: this._onSecurityMarkingChanged, value: this.props.listing.security_marking || "", label: "Security", disabled: inputDisabled, required: true, errorMessage: ErrorUtils_1.getPropErrorMessage("security_marking", validationErrors) }),
            React.createElement(ListingFormSection, { title: "Images", className: classNames.section, titleClassName: classNames.sectionTitle, bodyClassName: classNames.sectionBody },
                React.createElement(ListingImagesEditor, __assign({}, this.props))),
            React.createElement(ListingFormSection, { title: "Links", className: classNames.section, titleClassName: classNames.sectionTitle, bodyClassName: classNames.sectionBody },
                React.createElement(ListingLinkForm_1.ListingLinkForm, { listing: this.props.listing })),
            React.createElement(ListingFormSection, { title: "Settings", className: classNames.section, titleClassName: classNames.sectionTitle, bodyClassName: classNames.sectionBody },
                React.createElement(Checkbox_1.Checkbox, { onChange: this._onFeaturedChanged, checked: this.props.listing.is_featured ? true : false, label: "Featured", disabled: inputDisabled, styles: cbStyles }),
                React.createElement(Checkbox_1.Checkbox, { onChange: this._onEnabledChanged, checked: this.props.listing.is_enabled ? true : false, label: "Enabled", disabled: inputDisabled, styles: cbStyles }),
                React.createElement(Checkbox_1.Checkbox, { onChange: this._onPrivateChanged, checked: this.props.listing.is_private ? true : false, label: "Private", disabled: inputDisabled, styles: cbStyles }))));
    };
    ListingEditor = __decorate([
        mobx_react_1.observer
    ], ListingEditor);
    return ListingEditor;
}(React.Component));
exports.ListingEditor = ListingEditor;
var ListingSaveAction = /** @class */ (function (_super) {
    __extends(ListingSaveAction, _super);
    function ListingSaveAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClick = function () {
            _this.props.onSave(_this.props.listing);
        };
        _this._onRenderSyncIcon = function () {
            return React.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.small });
        };
        return _this;
    }
    ListingSaveAction.prototype.render = function () {
        var syncing = this.props.listing.saveSync.syncing;
        var syncSave = this.props.listing.saveSync.type === "save";
        return (React.createElement(Button_1.PrimaryButton, { className: "action save-action", onClick: this._onClick, iconProps: syncing && syncSave ? undefined : { iconName: "Save" }, onRenderIcon: syncing && syncSave ? this._onRenderSyncIcon : undefined, disabled: syncing }, syncing && syncSave ? "Saving..." : "Save"));
    };
    ListingSaveAction = __decorate([
        mobx_react_1.observer
    ], ListingSaveAction);
    return ListingSaveAction;
}(React.Component));
var ListingSubmitAction = /** @class */ (function (_super) {
    __extends(ListingSubmitAction, _super);
    function ListingSubmitAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClick = function () {
            _this.props.onSubmitForApproval(_this.props.listing);
        };
        _this._onRenderSyncIcon = function () {
            return React.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.small });
        };
        return _this;
    }
    ListingSubmitAction.prototype.render = function () {
        var syncing = this.props.listing.saveSync.syncing;
        var approvalStatus = this.props.listing.approval_status;
        if (approvalStatus === ListingApprovalStatus_1.ListingApprovalStatus.IN_PROGRESS || approvalStatus === ListingApprovalStatus_1.ListingApprovalStatus.REJECTED) {
            var syncSubmit = this.props.listing.saveSync.type === "submit";
            return (React.createElement(Button_1.PrimaryButton, { className: "action submit-action", onClick: this._onClick, iconProps: syncing && syncSubmit ? undefined : { iconName: "WorkFlow" }, onRenderIcon: syncing && syncSubmit ? this._onRenderSyncIcon : undefined, disabled: syncing, title: "Submit for Approval" }, syncing && syncSubmit ? "Submitting for Approval..." : "Submit for Approval"));
        }
        return null;
    };
    ListingSubmitAction = __decorate([
        mobx_react_1.observer
    ], ListingSubmitAction);
    return ListingSubmitAction;
}(React.Component));
var ListingCancelAction = /** @class */ (function (_super) {
    __extends(ListingCancelAction, _super);
    function ListingCancelAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClick = function () {
            _this.props.listing.reset();
            if (_this.props.onCancel) {
                _this.props.onCancel();
            }
        };
        return _this;
    }
    ListingCancelAction.prototype.render = function () {
        return React.createElement(Button_1.DefaultButton, { className: "action cancel-action", onClick: this._onClick, disabled: this.props.listing.saveSync.syncing }, "Cancel");
    };
    ListingCancelAction = __decorate([
        mobx_react_1.observer
    ], ListingCancelAction);
    return ListingCancelAction;
}(React.Component));
var ListingActions = /** @class */ (function (_super) {
    __extends(ListingActions, _super);
    function ListingActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingActions.prototype.render = function () {
        var styles = ListingForm_styles_1.getStyles(undefined, this.props.styles);
        return (React.createElement("div", { className: ListingForm_classNames_1.getClassNames(styles).actions },
            this.props.onCancel ? React.createElement(ListingCancelAction, __assign({}, this.props)) : undefined,
            this.props.onSave ? React.createElement(ListingSaveAction, __assign({}, this.props)) : undefined,
            this.props.onSubmitForApproval ? React.createElement(ListingSubmitAction, __assign({}, this.props)) : undefined));
    };
    return ListingActions;
}(React.Component));
var ListingSaveSync = /** @class */ (function (_super) {
    __extends(ListingSaveSync, _super);
    function ListingSaveSync() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingSaveSync.prototype.render = function () {
        if (this.props.listing.saveSync.error) {
            return (React.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.error },
                "Unable to save listing - ",
                this.props.listing.saveSync.error.message));
        }
        return null;
    };
    ListingSaveSync = __decorate([
        mobx_react_1.observer
    ], ListingSaveSync);
    return ListingSaveSync;
}(React.Component));
var ListingValidationErrors = /** @class */ (function (_super) {
    __extends(ListingValidationErrors, _super);
    function ListingValidationErrors() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingValidationErrors.prototype.render = function () {
        return React.createElement(ValidationErrors_1.ValidationErrors, { errors: this.props.listing.validationErrors });
    };
    ListingValidationErrors = __decorate([
        mobx_react_1.observer
    ], ListingValidationErrors);
    return ListingValidationErrors;
}(React.Component));
var ListingForm = /** @class */ (function (_super) {
    __extends(ListingForm, _super);
    function ListingForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingForm.prototype.render = function () {
        var styles = ListingForm_styles_1.getStyles(undefined, this.props.styles);
        return (React.createElement("div", { className: ListingForm_classNames_1.getClassNames(styles).root },
            React.createElement(ListingValidationErrors, __assign({}, this.props)),
            React.createElement(ListingSaveSync, __assign({}, this.props)),
            React.createElement(ListingEditor, __assign({}, this.props)),
            React.createElement(ListingActions, __assign({}, this.props))));
    };
    return ListingForm;
}(React.Component));
exports.ListingForm = ListingForm;
var ListingFormContainer = /** @class */ (function (_super) {
    __extends(ListingFormContainer, _super);
    function ListingFormContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderDone = function () {
            return React.createElement(ListingForm, { listing: _this.props.listingSupplier.value, onCancel: _this.props.onCancel, onSave: _this.props.onSave, onSubmitForApproval: _this.props.onSubmitForApproval });
        };
        return _this;
    }
    ListingFormContainer.prototype.render = function () {
        return React.createElement(Sync_1.Sync, { sync: this.props.listingSupplier.sync, onRenderDone: this._onRenderDone });
    };
    return ListingFormContainer;
}(React.Component));
exports.ListingFormContainer = ListingFormContainer;
